import { FormStore, GlobalStore } from "@roc/feature-app-core";
import { makeObservable } from "mobx";

const form = {
  fields: {
    reservesIfAny: {
      value: '',
      error: null,
      rule: '',
    },
    prepaymentPenalty: {
      value: '',
      error: null,
      rule: '',
    },
    payoffComments: {
      value: '',
      error: null,
      rule: '',
    },
    totalExtensionFee: {
      value: '',
      error: null,
      rule: '',
    },
    toChargesPrincipal: {
      value: '',
      error: null,
      rule: '',
    },
    waiverAmount: {
      value: '',
      error: null,
      rule: '',
    },
    waiverDescription: {
      value: '',
      error: null,
      rule: '',
    },
    otherFeesAdjustment: {
      value: '',
      error: null,
      rule: '',
    },
    otherFeesCategories: {
      value: '',
      error: null,
      rule: '',
    },
    crossInterest: {
      value: '',
      error: null,
      rule: '',
    },
    crossInterestDetail: {
      value: '',
      error: null,
      rule: '',
    },
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class PayoffFieldsFormStore extends FormStore {

  private globalStore: GlobalStore;

  constructor(globalStore: GlobalStore) {
    super({ ...form }, globalStore);
    makeObservable(this, {
    });
  }
}

export default PayoffFieldsFormStore;